import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const WideImage = () => import(/* webpackChunkName: "snippet-items-wide-image" */ 'components/SnippetTemplate/Items/WideImage')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(WideImage, {props: eval(this.elemId)})
        })
    }
}
